import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { setLocale } from 'yup';
import App from './App';
import yupLocale from '@/utils/yupLocale.ts';

import 'bootstrap/dist/css/bootstrap.min.css';
import '@/i18n/setupInternationalization';

setLocale(yupLocale);

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
